const modes = ['None', 'Sign', 'SignAndEncrypt'];
const policies = [
	{ label: 'None', value: 'None' },
	// { label: 'Basic128', value: 'Basic128' }, // ? Not Found
	// { label: 'Basic192', value: 'Basic192' }, // ? Not Found
	// { label: 'Basic128Rsa15', value: 'Basic128Rsa15' }, // Deprecated
	// { label: 'Basic192Rsa15', value: 'Basic192Rsa15' }, // ? Not Found
	{ label: 'Basic256', value: 'Basic256' },
	// { label: 'Basic256Rsa15', value: 'Basic256Rsa15' }, // ? Not Found
	{ label: 'Basic256Sha256', value: 'Basic256Sha256' },
	{ label: 'Aes128_Sha256_RsaOaep', value: 'Aes128_Sha256_RsaOaep' },
	{ label: 'Aes256_Sha256_RsaPss', value: 'Aes256_Sha256_RsaPss' },
	// { label: 'PubSub_Aes128_CTR', value: 'PubSub_Aes128_CTR' }, // ? PubSub
	// { label: 'PubSub_Aes256_CTR', value: 'PubSub_Aes256_CTR' }, // ? PubSub
];

export const SECURITY_MODES = modes.map(sm => ({ value: sm, label: sm }));
export const SECURITY_POLICIES = policies;

export const SECURITY_MODES_DEFAULT: string = modes[2]; // * mode: SignAndEncrypt
export const SECURITY_POLICIES_DEFAULT: string = policies[3].value; // * Basic256Sha256
export const SECURITY_MODES_DEFAULT_EDIT: string = modes[0]; // * None for legacy records (pre-encryption options)
export const SECURITY_POLICIES_DEFAULT_EDIT: string = policies[0].value; // * None for legacy records (pre-encryption options)
